export const SET_EDIT_SCHEDULE_PAGINATED_REPORT_PARAMETERS_LOADED = "SET_EDIT_SCHEDULE_PAGINATED_REPORT_PARAMETERS_LOADED";

export const setEditSchedulePaginatedReportParametersLoaded = (editSchedulePaginatedReportParametersLoaded: boolean) => {
    return {
        editSchedulePaginatedReportParametersLoaded,
        type: SET_EDIT_SCHEDULE_PAGINATED_REPORT_PARAMETERS_LOADED
    };
};
